import { uniq } from 'lodash'
import {
  IFacilityScheduleHour,
  IFacilityScheduleRulesUnloadTypes,
  IShipmentStopTypes,
  IWeekDaysEnum,
} from 'types/graphqlTypes'
import { getFacilityHoursForStopAndUnloadType } from './getFacilityHoursForStopAndUnloadType'

const labelsForDay: Record<IWeekDaysEnum, string> = {
  monday: 'Mon',
  tuesday: 'Tues',
  wednesday: 'Wed',
  thursday: 'Thurs',
  friday: 'Fri',
  saturday: 'Sat',
  sunday: 'Sun',
}

const weekdays: IWeekDaysEnum[] = [
  IWeekDaysEnum.monday,
  IWeekDaysEnum.tuesday,
  IWeekDaysEnum.wednesday,
  IWeekDaysEnum.thursday,
  IWeekDaysEnum.friday,
]

const hasSameHoursMonFri = (hours: IFacilityScheduleHour[]) => {
  const weekdayTimes = hours
    .filter(({ day }) => weekdays.includes(day as IWeekDaysEnum))
    .map(({ endTime, startTime }) => `${startTime}-${endTime}`)

  return weekdayTimes.length === 5 && uniq(weekdayTimes).length === 1
}

export const getAwardedLaneFacilityShiftRows = (
  hours: IFacilityScheduleHour[],
  stopType: IShipmentStopTypes,
  unloadType: IFacilityScheduleRulesUnloadTypes
) => {
  const relevantHours = getFacilityHoursForStopAndUnloadType(hours, stopType, unloadType)
  const sameHoursMonFri = hasSameHoursMonFri(relevantHours)

  const hoursToDisplay = sameHoursMonFri
    ? relevantHours.filter(({ day }) =>
        [IWeekDaysEnum.monday, IWeekDaysEnum.saturday, IWeekDaysEnum.sunday].includes(
          day as IWeekDaysEnum
        )
      )
    : relevantHours

  return hoursToDisplay.map(({ closed, day, endTime, startTime }) => ({
    label:
      sameHoursMonFri && day === IWeekDaysEnum.monday
        ? 'Mon-Fri'
        : labelsForDay[day as IWeekDaysEnum],
    value: closed ? 'Closed' : `${startTime} - ${endTime}`,
  }))
}
